import { createContext, useContext, useEffect, useState } from "react";
import { LANGS } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("evgp-lang") || "it");

  useEffect(() => {
    localStorage.setItem("evgp-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return <LanguageContext.Provider value={{ lang, setLang, t: LANGS[lang] }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
